const isLocal = false; //window.location.hostname === 'localhost'
const BaseUrl = isLocal ? 'http://localhost:8090' : 'https://parallel-iweek-6hg2nl4gha-uc.a.run.app';
///
export class HttpError extends Error {
    constructor(code, message) {
        super(message);
        this.status = code;
    }
}
const getHeaders = () => {
    const token = localStorage.getItem('token');
    return Object.assign(Object.assign({}, token ? { 'Authorization': token } : {}), { 'Content-Type': 'application/json', 'Accept': 'application/json' });
};
async function parseResponse(response) {
    const text = await response.text();
    if (response.status < 200 || response.status >= 300) {
        throw new HttpError(response.status, text);
    }
    try {
        return JSON.parse(text);
    }
    catch (e) {
        return text;
    }
}
async function getJson(url) {
    const response = await fetch(url, {
        headers: getHeaders()
    });
    return await parseResponse(response);
}
async function sendJson(url, data, method) {
    const response = await fetch(url, {
        method,
        headers: getHeaders(),
        body: JSON.stringify(data)
    });
    return await parseResponse(response);
}
const getPath = path => `${BaseUrl}/api/${path}`;
const postJson = (relPath, data) => sendJson(getPath(relPath), data, 'POST');
const putJson = (relPath, data) => sendJson(getPath(relPath), data, 'PUT');
export const sendHelpTicket = data => postJson('help-ticket', data);
export const getUser = id => getJson(getPath(`user/${id}`)).then((user) => ({
    firstName: user.firstName,
    lastName: user.surname
}));
export const login = (email, password) => postJson('login', { email, password }).then(resp => {
    localStorage.setItem('token', resp.token);
    return resp;
});
export const register = (firstname, lastname, email, phone, zip, password, bridgestoneId) => postJson('register', { firstname, lastname, email, phone, zip, password, bridgestoneId }).then(resp => {
    localStorage.setItem('token', resp.token);
    return resp;
});
export const join = (firstname, lastname, email, password) => postJson('join', { firstname, lastname, email, password }).then(resp => {
    localStorage.setItem('token', resp.token);
    return resp;
});
export const joinWithEmail = (email) => postJson('joinEmail', { email }).then(resp => {
    localStorage.setItem('token', resp.token);
    return resp;
});
export const emailExists = async (email) => {
    const response = await fetch(getPath('user/email-check'), {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({ email })
    });
    if (response.status >= 200 && response.status < 300)
        return true;
    throw new Error(await response.text());
};
export const setPreinvitePassword = (email, password) => postJson('user/set-invite-password', { email, password }).then(resp => {
    localStorage.setItem('token', resp.token);
    return resp;
});
export const getPoll = sessionId => postJson('poll', { sessionId });
export const vote = (sessionId, vote) => postJson('poll/vote', { sessionId, vote });
export const postReaction = (showId, data) => postJson('reaction', { showId, data });
export const forgotPassword = email => postJson('forgot-password', { email });
export const resetPassword = (token, password) => postJson('password', { token, password });
// const Schedule : ServerEvent[] = [
//   {
//     id: '2h22',
//     title: '2H22 Digital Conference',
//     desc: 'General Session & Key Product Story Presentation',
//     speakerData: [],
//     stream: {
//       live: {
//         type: 'dacast',
//         url: 'https://iframe.dacast.com/live/a6a09b2a-8994-2f31-d66f-f7ae60744549/7969b395-cd0e-fb08-19c2-e809895485f5'
//       },
//       replay: {
//         type: 'vimeo',
//         url: '629173336'
//       }
//     },
//     startDate: '2021/10/16',
//     startTime: '7:00',
//     timeZone: 'EDT',
//     duration: 4500
//   }
// ]
export const getSchedule = () => getJson(getPath('schedule'))
    // Promise.resolve(Schedule)
    .then(events => events.map(event => {
    // Some browers require date string with / vs -
    const startTime = new Date(`${event.startDate.replaceAll('-', '/')} ${event.startTime} ${event.timeZone}`);
    const endTime = new Date(startTime.getTime() + event.duration * 1000);
    // Clean server data
    return {
        id: event.id,
        title: event.title || '',
        description: event.desc || '',
        duration: event.duration,
        speakers: event.speakers,
        liveStream: event.liveStream,
        replayStream: event.replayStream,
        startTime,
        endTime,
        chatChannel: event.chatChannel
    };
}).sort((a, b) => a.startTime - b.startTime));
const Assets = {
    'hub': {
        openDateTime: "2021/08/10 09:0:0 CDT",
        beforeOpenText: '',
        title: 'GUEST PRESENTER BIOS',
        subtitle: 'The documents below introduce our guest presenters. Please review in advance of Wednesday’s breakout sessions to learn more about your session guest speakers.',
        assets: [
            { title: "Marcus Buckingham", url: '/asset/Keynote Speaker Bio - Buckingham, Marcus.pdf', type: 'pdf', image: '1_MarcusBuckingham.png' },
            { title: "Dani Silva", url: '/asset/Partner Session Bios - Silva, Dani.pdf', type: 'pdf', image: '2_DaniSilva.png' },
            { title: "Courtney Barlar", url: '/asset/Partner Session Bios - Barlar, Courtney.pdf', type: 'pdf', image: '3_CourtneyBarlar.png' },
            { title: "Leslie Watt", url: '/asset/Partner Session Bios - Watt, Leslie.pdf', type: 'pdf', image: '4_LeslieWatt.png' },
            { title: "Craig Harper", url: '/asset/Partner Session Bios - Harper, Craig.pdf', type: 'pdf', image: '5_CraigHarper.png' },
            { title: "Don Burnette", url: '/asset/Partner Session Bios - Burnette, Don.pdf', type: 'pdf', image: '6_DonBurnette.png' },
            { title: "Bill Combs", url: '/asset/Partner Session Bios - Combs, Bill.pdf', type: 'pdf', image: '7_BillCombs.png' },
            { title: "Mark Kroese", url: '/asset/Partner Session Bios - Kroese, Mark.pdf', type: 'pdf', image: '8_MarkKroese.png' },
        ]
    },
    // 'technology': {
    //   openDateTime: "2021/08/10 09:0:0 CDT",
    //   beforeOpenText: 'Assets will become available on August 10th at 9am CST and will be available until August 24th',
    //   title: 'Tire Technology Videos',
    //   assets: [
    //     {title: 'Potenza 980AS Engineer Talk', url: 'https://player.vimeo.com/video/584904435?badge=0&autoplay=1&loop=1&autopause=0&player_id=0&app_id=58479', type: 'vimeo'},
    //     {title: 'Potenza Sport Engineer Talk', url: 'https://player.vimeo.com/video/584898740?badge=0&autoplay=1&loop=1&autopause=0&player_id=0&app_id=58479', type: 'vimeo'},
    //     {title: 'Engineering and Chemistry Talk', url: 'https://player.vimeo.com/video/584902396?badge=0&autoplay=1&loop=1&autopause=0&player_id=0&app_id=58479', type: 'vimeo'},
    //     {title: 'Tire Trends and Tech Talk', url: 'https://player.vimeo.com/video/584903432?badge=0&autoplay=1&loop=1&autopause=0&player_id=0&app_id=58479', type: 'vimeo'}
    //   ]
    // },
    // 'marketing': {
    //   openDateTime: "2021/08/10 09:0:0 CDT",
    //   beforeOpenText: 'Assets will become available on August 10th at 9am CST and will be available until August 24th',
    //   title: 'Marketing Materials',
    //   assets: [
    //     {title: 'Potenza Sport Sales Sheet', url: '/static/SS_EN_BS_POTENZA_SPORT.PDF', type: 'pdf'},
    //     {title: 'Potenza RE980AS+ Sales Sheet', url: '/static/SS_EN_BS_POTENZA_RE980AS_PLUS.pdf', type: 'pdf'},
    //     {title: 'Potenza Responsive Handling Short Video', url: 'https://player.vimeo.com/video/575830972?badge=0&autoplay=1&loop=1&autopause=0&player_id=0&app_id=58479', type: 'vimeo'},
    //     {title: 'Potenza Responsive Handling Long Video', url: 'https://player.vimeo.com/video/575829362?badge=0&autoplay=1&loop=1&autopause=0&player_id=0&app_id=58479', type: 'vimeo'},
    //   ]
    // }
};
export const getAssets = id => Promise.resolve(Assets[id] || Object.values(Assets)[0]);
export const getNewPartners = () => {
    return [
        {
            "file": "AlexGuerrero",
            "name": "Alex Guererro",
            "function": "SVP/General Merchandiser Global Product",
            "answer1": "Travel, Tennis and Explore.",
            "answer2": "Building my merchandising experience by working with some of the toughest buying groups for Federated, Kohls and JCPenney. It was the toughest training, but the most rewarding.",
            "answer3": "To continue to transform and ready the brand and company for the next 130+ years!"
        },
        {
            "file": "AndiDonovan",
            "name": "Andi Donovan",
            "function": "SVP Wholesale and CCG",
            "answer1": "See live music and travel",
            "answer2": "Worked to keep a team motivated and keep Borders, Inc. going through Chapter 11.  I developed better decisiveness and crisis management skills as a result.",
            "answer3": "To bring the amazing talent at Carhartt together to deepen our brand connection with a more diverse group of consumers.  To grow the company and grow together."
        },
        {
            "file": "JanetRies",
            "name": "Janet Ries",
            "function": "VP Marketing",
            "answer1": "Run, Mountain Bike, Kayak",
            "answer2": "Being a challenger brand in a very aggressive space presented the need to think and act differently in order to be a meaningful brand for our customers and consumers. You couldn’t rest on the laurels of what you were yesterday, you had to challenge the strategy, the execution of product, marketing and distribution to be break through the clutter.",
            "answer3": "Preparing the brand and laying a solid foundation for the next 130 years."
        },
        {
            "file": "DaniloAmoretty",
            "name": "Danilo Amoretty",
            "function": "SVP Global Product Supply Operations",
            "answer1": "Biking, Running, Traveling",
            "answer2": "The status quo has been a formidable competitor throughout my career.  I continue to challenge the status quo every day.",
            "answer3": "Having a lot fun while delivering value for our Brand, Consumers, and all of our associates."
        },
        {
            "file": "ScottZimmerman",
            "name": "Scott Zimmerman",
            "function": "VP Merchandising",
            "answer1": "Coach my daughter’s soccer team, travel, read, and run",
            "answer2": "The pandemic has brought on complexities that I have never seen for brands, product, and supply networks.  We continue to evolve and get better despite the challenges and will come out of this stronger than we have ever been.  No doubts.",
            "answer3": "Our best is still ahead of us and we have to continue to grind to deliver on our brand promise to our existing and up and coming consumers.  We will deliver the very best of Carhartt and create separation in the market."
        },
        {
            "file": "BenEwy",
            "name": "Ben Ewy",
            "function": "VP Design and Research and Development",
            "answer1": "I am an administrator in a local bourbon club and enjoy sharing good pours and great conversation.",
            "answer2": "Making a shift from working in person to working remote was difficult for everyone, especially in Design where we have to work with samples, colors, materials, etc., that can't be replicated digitally.  Fall 2022 is the first full season designed by remote and we did it by creating new tools, finding alternative ways to collaborate, trusting each other even more and continuing to stay close to our consumers.  Hopefully you'll agree this is one of our best seasons ever!",
            "answer3": "Creating product and experiences that brings new consumers to our brand while continuing to resonate with our existing customers."
        },
        {
            "file": "JennyHall",
            "name": "Jenny Hall",
            "function": "Director of Project Catalyst",
            "answer1": "Outside exercise and activities",
            "answer2": "I \"survived\" Project Catalyst, at home, during a pandemic, with my then 3 and 6 year old. Need I say more? It took running regularly with a friend, a supportive spouse and a sense of humor to make it through.",
            "answer3": "The challenges and opportunities that come with growth, both on a personal level and a professional level."
        },
        {
            "file": "LindaHubbard",
            "name": "Linda Hubbard",
            "function": "President/COO",
            "answer1": "Visit the national parks—have been to 20+ so far and I am hiking Acadia this week in Maine",
            "answer2": "The early months of the pandemic last year and the Great Recession of 2008 were both challenging times due to the uncertainty of events happening around the world that we couldn’t control. I was in a leadership position at Carhartt for both of those crises and felt a tremendous responsibility to our associates and their families. I learned to be nimble, to take in information from many different sources to make informed decisions, and to rely on business networks and relationships to talk through options and impacts. Most importantly, I learned that decisions had to be made in the absence of a complete set of facts.",
            "answer3": "I am looking forward to many stories about new consumers and new associates that build an emotional connection to our brand through their partnership with us in building a better world with all hard-working people."
        },
        {
            "file": "ToddCorley",
            "name": "Todd Corley",
            "function": "SVP Inclusion and Sustainability",
            "answer1": "Watch (preferably in person) college basketball",
            "answer2": "Creating a roadmap to implement a large-scale culture-change initiative, in the face of competing priorities. The lift was enormous, but well worth it.",
            "answer3": "Creating a brand- and an employment-experience that resonates with ALL hardworking people, while having a positive influence on communities – large and small; rural, suburban, or densely populated cities"
        },
        {
            "file": "PaulHundhammer",
            "name": "Paul Hundhammer",
            "function": "SVP Sales",
            "answer1": "Golf, hike, ski",
            "answer2": "Failing to get to the big leagues. Inspired me to work harder in every job, build relationships and be accountable.",
            "answer3": "Operational excellence"
        },
        {
            "file": "TonyGariety",
            "name": "Tony Gariety",
            "function": "VP Distribution and Logistics",
            "answer1": "Woodworking, Hunting, and Fishing",
            "answer2": "Managing a DC that had been open for a week and then was hit by Hurricane Charlie and two other hurricanes in concurrent 2 week increments.  It certainly was a lesson in crisis mgt but managing and dealing with the people to help them but also get us through the challenge at hand.  Open and honest straight talk of the condition and what we needed to do to get through and back on track.",
            "answer3": "Continue to build out a DC network and capacity to meet our growing demand."
        },
        {
            "file": "FredEsseily",
            "name": "Fred Esseily",
            "function": "",
            "answer1": "Enjoy time with my wife and three girls",
            "answer2": "Anticipating the next supply chain disruption is always difficult.  As we perceiver through these unprecedented times of disruptions, it emphasized the needs of scenario planning and having an executable plan with a supply chain that is agile and resilient.  One thing I have learned is that our people are our strongest asset.",
            "answer3": "Continuing to represent the Brand as well as those that preceded me did.  It is an exciting time for Carhartt and I am proud to be a part of such a great organization with purpose."
        },
        {
            "file": "WilliamHardy",
            "name": "William Hardy",
            "function": "SVP Sourcing",
            "answer1": "Yard work is my favorite right now",
            "answer2": "On more than one occasion having to tell an associate of the unexpected loss of a loved one during the workday. It helped me understand the real meaning of when we say our co-workers are like family. It put Steve Carter’s words of it’s more than just coats and jackets into perspective. W have many responsibilities as leaders.",
            "answer3": "Creating a service quality = to our product quality with a talented team that will help pave the way for the Next Frontier."
        },
        {
            "file": "JoeDonLong",
            "name": "Joe Don Long",
            "function": "VP Global Quality",
            "answer1": "Photography outdoors in a beautiful setting",
            "answer2": "The cotton crisis in 2010 was tough. We overcame it through global teamwork, ideation and information sharing. I am a better person because of it.",
            "answer3": "Positioning the company for another 130 years through a legacy of leaders."
        }
    ];
};
